// @flow
import { connect } from 'react-redux';
import type { State } from '../../../../../types';
import zoneActions from '../../../../../actions/zoneActions';
import { drawingSelector, drawingShapeTypeSelector, drawingShapeSelector, drawingZoneSelector } from '../../../../../selectors/zoneSelectors';
import Drawing from '../Drawing';
import type { Props } from '../Drawing';

const mapStateToProps = (state: State) => {
    return {
        drawingEnabled: Boolean(drawingSelector(state)),
        type: drawingShapeTypeSelector(state),
        shape: drawingShapeSelector(state),
        newZone: !drawingZoneSelector(state)
    };
};

const mapDispatchToProps = {
    setShape: zoneActions.setDrawingShape
};

export default connect<Props, *, _, _, _, _>(mapStateToProps, mapDispatchToProps)(Drawing);